/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * States for streaming session lifecycle.
 * Tracks the current status of the playback session with the backend.
 */
export enum SessionState {
  /**
   * Session encountered an error.
   */
  ERROR = "ERROR",

  /**
   * Session creation failed for a reason that says nothing about the viewer's
   * right to watch — a timeout, a network fault, a server-side error.
   *
   * Distinct from {@link ERROR} because the response is the opposite one:
   * playback continues on the URL already resolved, and nothing is shown to
   * the viewer. Only failures that carry no entitlement or policy meaning
   * reach this state; a denial always fails closed as {@link ERROR}.
   */
  FAILED_OPEN = "FAILED_OPEN",

  /**
   * No active session - initial state.
   */
  NONE = "NONE",

  /**
   * Session successfully created and active.
   */
  SUCCESS = "SUCCESS",

  /**
   * Session service is unreachable.
   */
  UNREACHABLE = "UNREACHABLE"
}
